export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration.vue?vue&type=template&id=5eb82e73&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bonuses/registration.vue?vue&type=template&id=5eb82e73&scoped=true
// module id = Biz0
// module chunks = 0